import tw from 'tailwind-styled-components';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.85);
    focus:outline-none;
    display:flex;
  }
`;
GlobalStyle.displayName = 'GlobalStyle';

export const BackgroundWrapper = tw.div`
  absolute
  h-full
  w-full
`;
BackgroundWrapper.displayName = 'BackgroundWrapper';

export const TextWrapper = tw.div`
  text-center
  pt-20
  md:pt-10
  px-4 
  md:mb-10
  sm:mb-10
`;
TextWrapper.displayName = 'TextWrapper';

export const TopRightCornerBlob = styled.div`
  position: absolute;
  right: -13%;
  top: 1%;
  z-index: -1;

  @media screen and (min-width: 768px) {
    top: -20%;
    right: -23%;
  }
  @media screen and (min-width: 1024px) {
    top: -20%;
    right: -18%;
  }
  @media screen and (min-width: 1440px) {
    right: -13%;
  }
`;
TopRightCornerBlob.displayName = 'TopRightCornerBlob';

export const TopRightCornerBlobMobile = styled.div`
  position: absolute;
  z-index: -1;
  right: -13%;
  top: -7%;
  @media screen and (min-width: 600px) {
    top: -7%;
    right: -5%;
  }
`;
TopRightCornerBlob.displayName = 'TopRightCornerBlob';

export const TopRightCornerAsset = styled.div`
  position: absolute;
  top: -6%;
  z-index: 1;
  right: -10%;
  width: 30%;
  @media screen and (min-width: 768px) {
    top: -15%;
    right: -8%;
    width: 30%;
  }
  @media screen and (min-width: 1024px) {
    top: -20%;
    right: -13%;
    width: 30%;
  }
  @media screen and (min-width: 1440px) {
    top: -25%;
    right: -13%;
    width: 30%;
  }
`;
TopRightCornerAsset.displayName = 'TopRightCornerAsset';
